/* IM Quick View – logique (image, titre, prix, tailles, flocage, CTA) */
(() => {
  console.log('[IM] QV script (clean) chargé');

  const root = document.getElementById('im-qv');
  if (!root) return;

  // --- DOM refs
  const title        = root.querySelector('#im-qv-title');
  const priceNode    = root.querySelector('#im-qv-price');
  const thumb        = root.querySelector('#im-qv-thumb');
  const form         = root.querySelector('#im-qv-form');
  const optBox       = root.querySelector('#im-qv-options');
  const varId        = root.querySelector('#im-qv-variant-id');
  const btnAdd       = root.querySelector('.im-qv__submit');
  const sizeCurrent  = root.querySelector('#im-qv-size-current');

  // Flocage
  const flocageToggle = root.querySelector('#im-qv-flocage');
  const flocageFields = root.querySelector('#im-qv-flocage-fields');
  const numeroInput   = root.querySelector('input[name="properties[Numéro]"]');
  const numeroHint    = root.querySelector('.im-qv__hint');

  // --- State
  let product = null;
  let currentVariant = null;
  let selections = {}; // { 'Taille': 'S', ... }
  let isOpen = false;

  // --- Utils
  const money = (cents) => {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: cur
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Produit introuvable');
    return res.json();
  };

  // --- Open / Close (sans empilement de listeners)
  const open = () => {
    if (isOpen) return;
    isOpen = true;
    root.style.display = 'block';
    // force reflow pour activer la transition CSS
    // eslint-disable-next-line no-unused-expressions
    root.offsetHeight;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const close = () => {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    const onEnd = () => {
      root.style.display = 'none';
      root.removeEventListener('transitionend', onEnd);
    };
    root.addEventListener('transitionend', onEnd);
  };

  // Fermer : scrim / bouton / ESC
  root.addEventListener('click', (e) => {
    if (e.target.closest('.im-qv__scrim,[data-im-qv-close]')) {
      e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (isOpen && e.key === 'Escape') close();
  });

  // --- Variants
  const setVariantBySelections = () => {
    if (!product) return;
    const v = product.variants.find((variant) =>
      product.options.every((opt, i) => {
        const wanted = selections[opt.name] ?? variant[`option${i + 1}`];
        return variant[`option${i + 1}`] === wanted;
      })
    ) || product.variants[0];

    currentVariant = v;
    if (varId) varId.value = v.id;
    if (priceNode) priceNode.textContent = money(v.price);
    if (btnAdd) btnAdd.disabled = !v.available;

    const sizeOpt = product.options.find((o) => /size|taille/i.test(o.name));
    if (sizeOpt) {
      const idx = product.options.indexOf(sizeOpt);
      sizeCurrent.textContent = v[`option${idx + 1}`] || '—';
    } else {
      sizeCurrent.textContent = '—';
    }
  };

  const renderOptions = () => {
    if (!optBox) return;
    optBox.innerHTML = '';
    selections = {};

    const ordered = [...product.options].sort((a, b) => {
      const as = /size|taille/i.test(a.name) ? -1 : 0;
      const bs = /size|taille/i.test(b.name) ? -1 : 0;
      return as - bs;
    });

    ordered.forEach((opt) => {
      const realIndex = product.options.findIndex((o) => o.name === opt.name);
      const values = [...new Set(product.variants.map((v) => v[`option${realIndex + 1}`]))];

      const group = document.createElement('div');
      group.className = 'im-qv__opt-group';

      values.forEach((val) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'im-qv__opt-btn';
        btn.textContent = val;
        btn.dataset.optName = opt.name;
        btn.dataset.optIndex = String(realIndex);

        btn.addEventListener('click', () => {
          optBox.querySelectorAll(`.im-qv__opt-btn[data-opt-name="${CSS.escape(opt.name)}"]`)
            .forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selections[opt.name] = val;
          setVariantBySelections();
        });

        group.appendChild(btn);
      });

      optBox.appendChild(group);
    });

    const v0 = product.variants.find((v) => v.available) || product.variants[0];
    product.options.forEach((opt, i) => (selections[opt.name] = v0[`option${i + 1}`]));

    Object.entries(selections).forEach(([name, val]) => {
      optBox.querySelectorAll(`.im-qv__opt-btn[data-opt-name="${CSS.escape(name)}"]`)
        .forEach((el) => { if (el.textContent === val) el.classList.add('is-active'); });
    });

    setVariantBySelections();
  };

  const renderProduct = (p) => {
    product = p;
    if (title) title.textContent = product.title;
    if (priceNode) priceNode.textContent = money(product.price || product.variants[0].price);
    if (thumb) {
      thumb.innerHTML = (product.images && product.images.length)
        ? `<img src="${product.images[0]}" alt="${product.title}">`
        : '';
    }
    renderOptions();
  };

  // --- Flocage (stable)
  const updateFlocageVisibility = () => {
    if (!flocageToggle || !flocageFields) return;
    const on = !!flocageToggle.checked;

    // Montre/Cache
    flocageFields.hidden = !on;
    flocageFields.style.display = on ? 'block' : 'none';

    // Active/Désactive inputs SANS les vider (on ne touche pas à la valeur saisie)
    flocageFields.querySelectorAll('input,select,textarea,button').forEach((el) => {
      el.disabled = !on;
    });

    if (!on && numeroHint) numeroHint.textContent = '';
  };

  // Numéro : seulement chiffres, max 3 — validation douce (pas de blocage clavier)
  const handleNumeroInput = () => {
    if (!numeroInput) return;
    const onlyDigits = numeroInput.value.replace(/[^\d]/g, '');
    if (onlyDigits !== numeroInput.value) {
      numeroInput.value = onlyDigits;
    }
    if (numeroInput.value.length > 3) {
      numeroInput.value = numeroInput.value.slice(0, 3);
    }
    if (numeroHint) numeroHint.textContent = '';
  };

  // Attacher 1 seule fois
  flocageToggle?.addEventListener('change', updateFlocageVisibility);
  numeroInput?.addEventListener('input', handleNumeroInput);

  // --- Ajout panier
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!currentVariant) return;
    btnAdd.disabled = true;

    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!res.ok) throw new Error('Erreur ajout panier');

      document.querySelector('[data-cart-trigger], .js-open-cart, [href="#cart-drawer"]')?.click();
      close();
    } catch (err) {
      console.error(err);
      btnAdd.disabled = false;
    }
  });

  // --- Ouverture QV
  window.addEventListener('im:qv:open', async (ev) => {
    open();

    // UI placeholders
    btnAdd.disabled = true;
    title.textContent = 'Chargement…';
    priceNode.textContent = '';
    thumb.innerHTML = '<div style="width:90px;height:90px;background:#f3f3f3;border-radius:14px;"></div>';
    optBox.innerHTML = '<div style="padding:12px 0;color:#999;text-align:center;">Préparation des tailles…</div>';
    sizeCurrent.textContent = '—';

    // Flocage OFF par défaut à l’ouverture
    if (flocageToggle) flocageToggle.checked = false;
    updateFlocageVisibility();

    try {
      const p = await fetchProduct(ev.detail.handle);
      renderProduct(p);
      // Valide la disponibilité du variant courant
      btnAdd.disabled = !(currentVariant?.available ?? true);
    } catch (e) {
      console.error(e);
      title.textContent = 'Produit indisponible';
      btnAdd.disabled = true;
    }
  });

  // --- TRIGGER (bouton sur la carte produit)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.im-mpb, [data-im-qv-open]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    window.dispatchEvent(new CustomEvent('im:qv:open', { detail: { handle } }));
  }, true);
})();

/* --- Scroll lock version iOS FIX --- */
let _scrollY = 0;
let _lockPaddingApplied = false;

const lockScroll = () => {
  _scrollY = window.scrollY || document.documentElement.scrollTop;
  document.body.dataset.scrollY = _scrollY; // pour traçage debug

  // sur iOS : on évite position:fixed (bug clic) → on utilise overscroll:hidden
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'relative';
  document.body.style.touchAction = 'none';

  // Ajout léger padding pour éviter le “jump” si scrollbar
  if (window.innerWidth > document.documentElement.clientWidth && !_lockPaddingApplied) {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollBarWidth}px`;
    _lockPaddingApplied = true;
  }
};

const unlockScroll = () => {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.touchAction = '';
  if (_lockPaddingApplied) {
    document.body.style.paddingRight = '';
    _lockPaddingApplied = false;
  }
  window.scrollTo(0, parseInt(document.body.dataset.scrollY || '0', 10));
};

/* --- Open / Close (corrigé iOS click offset) --- */
const open = () => {
  if (isOpen) return;
  isOpen = true;
  root.style.display = 'block';
  root.offsetHeight; // force reflow
  root.classList.add('is-open');
  root.setAttribute('aria-hidden', 'false');
  lockScroll(); // ✅ nouvelle version stable
};

const close = () => {
  if (!isOpen) return;
  isOpen = false;
  root.classList.remove('is-open');
  root.setAttribute('aria-hidden', 'true');
  const onEnd = () => {
    root.style.display = 'none';
    root.removeEventListener('transitionend', onEnd);
  };
  root.addEventListener('transitionend', onEnd);
  unlockScroll();
};

/* QV – cacher la bulle à l'ouverture, la remettre à la fermeture (robuste) */
(() => {
  const qv = document.getElementById('im-qv');
  if (!qv) return;

  // 1) Sélecteurs connus + fallback heuristique (bulle fixe en bas à droite)
  const KNOWN = [
    '.shopify-chat-bubble',
    '.gorgias-chat', '#gorgias-chat-container', 'iframe[src*="gorgias"]',
    '.tidio-chat', '#tidio-chat', 'iframe[src*="tidio"]',
    '.crisp-client', 'iframe[src*="crisp"]',
    '.intercom-lightweight-app', 'iframe[src*="intercom"]',
    '#tawkchat-minified', 'iframe[src*="tawk"]',
    '#hubspot-messages-iframe-container', 'iframe[id^="launcher"]'
  ];

  const saved = new WeakMap();

  const collectWidgets = () => {
    const set = new Set();
    KNOWN.forEach(s => document.querySelectorAll(s).forEach(el => set.add(el)));

    // Heuristique : tout petit élément "fixed" proche bas-droite avec z-index élevé
    document.querySelectorAll('body *').forEach(el => {
      if (!(el instanceof HTMLElement) || qv.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      const nearBR = (innerWidth - r.right < 180) && (innerHeight - r.bottom < 180);
      const small  = r.width <= 360 && r.height <= 360;
      const zi     = parseInt(cs.zIndex || '0', 10);
      if ((nearBR && small && zi > 1000) || (el.tagName === 'IFRAME' && zi > 1000)) set.add(el);
    });

    return [...set];
  };

  const hide = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) saved.set(el, el.getAttribute('style') || '');
      el.style.cssText += ';opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
    });
  };

  const show = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) return;
      const s = saved.get(el);
      s ? el.setAttribute('style', s) : el.removeAttribute('style');
      saved.delete(el);
    });
  };

  const isOpen = () => {
    const cs = getComputedStyle(qv);
    return qv.classList.contains('is-open') ||
           qv.getAttribute('aria-hidden') === 'false' ||
           cs.display !== 'none';
  };

  const sync = () => (isOpen() ? hide() : show());

  // 2) Réagit aux changements d’état (open/close)
  new MutationObserver(sync).observe(qv, {
    attributes: true,
    attributeFilter: ['class','style','aria-hidden']
  });

  // 3) Hooks explicites : ton code déclenche déjà im:qv:open ; on écoute aussi la fermeture
  window.addEventListener('im:qv:open', () => setTimeout(sync, 0));
  document.addEventListener('click', e => {
    if (e.target.closest('[data-im-qv-close]') || e.target.closest('.im-qv__scrim, .im-qv__backdrop')) {
      setTimeout(sync, 0);
    }
  }, true);

  // 4) Filet périodique (si un script change la QV sans attributs)
  setInterval(sync, 400);

  // 5) Premier passage
  sync();
})();
